import { css, Theme } from "@emotion/react";

export const ModalAnnouncementStyle = {
  index: css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
  header: ({ fontSize }: Theme) => css`
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    color: #5aaaf3;
    font-size: ${fontSize[18]};
    height: auto;
    line-height: 38px;
    padding: 4px 48px;
    font-weight: bold;
    position: relative;
    border-bottom: 2px solid #d9dee7;
  `,

  btnClose: css`
    position: absolute;
    right: 0;
    top: 8px;
    font-size: 26px;
    background-color: unset !important;

    svg {
      fill: #bdbdbd;
      height: 30px;
    }
    &:hover {
      svg {
        fill: #aaaaaa;
      }
    }
  `,
  mobileList: css`
    padding: 12px 12px 0;
    background-color: #eef2f6;
    height: 100%;
    box-sizing: border-box;

    .list {
      background-color: #f7f9fb;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: 70vh;
      overflow-y: auto;
    }

    .item {
      padding: 14px 18px;
      border-bottom: 1px solid #e3e8f0;
      cursor: pointer;
      transition: background-color 150ms ease;
      background-color: #f7f9fb;

      &:hover {
        background-color: #eaf0f7;
      }

      &.active {
        background-color: #06396a;
        border-left: 3px solid #5aaaf3;
        padding-left: 15px;

        h3 {
          color: #f8fafc;
        }

        p,
        .time span {
          color: #dbe6f5;
        }
      }

      h3 {
        font-weight: 600;
        font-size: 14px;
      }

      p {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
        margin-top: 2px;
      }

      .time {
        display: flex;
        align-items: center;
        margin-top: 2px;
        justify-content: end;

        span {
          font-size: 11px;
          text-align: right;
          width: 100%;
        }
      }
    }
  `,
  content: css`
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 16px;
    height: 100%;
    padding: 16px 20px 24px;
    max-height: 70vh;
    box-sizing: border-box;
    background-color: #eef2f6;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      height: auto;
    }
  `,
  listPanel: css`
    border-radius: 10px;
    background-color: #f7f9fb;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: 70vh;

    .list {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      flex: 1;
      height: 100%;
    }

    .item {
      padding: 14px 18px;
      border-bottom: 1px solid #e3e8f0;
      cursor: pointer;
      transition: background-color 150ms ease;

      &:hover {
        background-color: #eaf0f7;
      }

      &.active {
        background-color: #06396a;
        border-left: 3px solid #5aaaf3;
        padding-left: 15px;

        h3 {
          color: #f8fafc;
        }

        p,
        .time span {
          color: #dbe6f5;
        }
      }

      h3 {
        font-weight: 600;
        font-size: 14px;
      }

      p {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
        margin-top: 2px;
      }

      .time {
        display: flex;
        align-items: center;
        margin-top: 2px;
        justify-content: end;

        span {
          font-size: 11px;
          text-align: right;
          width: 100%;
        }
      }
    }
  `,
  detailPanel: css`
    border-radius: 10px;
    background-color: #e3e9f1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 70vh;
    overflow-y: auto;
    .placeholder {
      padding: 24px;
      text-align: center;
      color: #9b9b9b;
      font-size: 14px;
    }
  `,
  detail: css`
    padding: 18px 24px;
    overflow-y: auto;
    flex: 1;

    .title {
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 6px;
      color: #2b2b2b;
      text-align: center;
    }

    .time {
      font-size: 12px;
      color: #9b9b9b;
      margin-bottom: 12px;
      text-align: center;
    }

    .content {
      font-size: 14px;
      color: #333333;
      line-height: 1.6;

      img {
        max-width: 100%;
        height: auto;
      }
    }
  `,
  empty: css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  `,
  actions: css`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 0 20px 20px;
    background-color: #eef2f6;
    padding-top: 12px;

    .ant-btn {
      min-width: 120px;
      border-radius: 6px;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
    }
  `,
  mobileDetail: css`
    padding: 16px 20px 24px;
    background-color: #eef2f6;
    height: 100%;
    box-sizing: border-box;

    .back {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: #2f6bb2;
      font-weight: 600;
      padding: 0;
      margin-bottom: 12px;
    }

    .detail {
      background-color: #ffffff;
      border-radius: 10px;
      padding: 18px 16px;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    }

    .title {
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 6px;
      color: #1f2d3d;
      text-align: center;
    }

    .time {
      font-size: 12px;
      color: #7a8ba1;
      margin-bottom: 12px;
      text-align: center;
    }

    .content {
      font-size: 14px;
      color: #333333;
      line-height: 1.6;

      img {
        max-width: 100%;
        height: auto;
      }
    }
  `,
};
